<template>
  <CDropdown variant="nav-item">
    <CDropdownToggle placement="bottom-end" :caret="false" @click="activeLink">
      <CIcon class="my-1 mx-2" icon="cil-user" size="lg" />
      <span class="username">
        {{ payload.firstname }} {{ payload.lastname }} ({{ payload.userGroup }})
      </span>
    </CDropdownToggle>
    <CDropdownMenu class="pt-0">
      <CDropdownHeader
        component="h6"
        class="dropdown-header bg-light dark:bg-white dark:bg-opacity-10 py-2"
      >
        Account
      </CDropdownHeader>
      <CDropdownDivider />
      <CDropdownItem href="/#/backend/account/password">
        <CIcon icon="cil-key" /> Passwort ändern
      </CDropdownItem>
      <CDropdownItem href="/#/backend/logout">
        <CIcon icon="cil-lock-locked" /> Logout
      </CDropdownItem>
    </CDropdownMenu>
  </CDropdown>
</template>

<script>
import AuthService from '@/_services/auth.service'
export default {
  name: 'UmwaHeaderDropdownAccnt',
  setup() {
    return {
      itemsCount: 42,
      payload: '',
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn
    },
  },
  created() {
    if (this.loggedIn === true) {
      this.payload = AuthService.getPayload()
    }
  },
  methods: {
    activeLink(event) {
      event.preventDefault()
    },
  },
}
</script>
